import React from 'react'
import { Card, Col } from 'react-bootstrap'
import { Bar, CartesianGrid, ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

export const CEOCacLtvGraph = () => {

    const cacLtvData = [
        { year: '2016', cac: 130, ltv: 150, ratio: 1.15 },
        { year: '2017', cac: 135, ltv: 205, ratio: 1.52 },
        { year: '2018', cac: 135, ltv: 270, ratio: 2.00 },
        { year: '2019', cac: 140, ltv: 335, ratio: 2.39 },
        { year: '2020', cac: 140, ltv: 400, ratio: 2.85 },
        { year: '2021', cac: 148, ltv: 460, ratio: 3.10 },
        { year: '2022', cac: 152, ltv: 495, ratio: 3.25 },
    ];


    return (
        <Col lg={4}>
            <Card className="h-100 shadow-sm rounded-3 p-0" style={{ backgroundColor: "#ffffff", border: "1px solid #e3e3e3" }}>
                <Card.Body className="px-3 pt-3 pb-2 d-flex flex-column justify-content-between h-100">
                    <div className="">
                        <span className="d-block mb-0 pb-0" style={{ fontWeight: 500, fontSize: '16px', }}>
                            CAC vs LTV Ratio
                        </span>
                        <span className="text-muted d-block" style={{ fontSize: "11px" }}>
                            Unit economics over time
                        </span>
                    </div>
                    <hr style={{ height: '0.1rem' }} />

                    <div className="d-flex flex-wrap gap-3 mb-2" style={{ fontSize: "11px" }}>
                        <div className="d-flex align-items-center gap-1">
                            <span className="rounded-1" style={{ width: 10, height: 10, backgroundColor: "#c7d2fe" }}></span>
                            <span className="text-muted fw-medium">Customer Acquisition Cost(CAC)</span>
                        </div>
                        <div className="d-flex align-items-center gap-1">
                            <span className="rounded-1" style={{ width: 10, height: 10, backgroundColor: "#849eff" }}></span>
                            <span className="text-muted fw-medium">Lifetime value(LTV)</span>
                        </div>
                        <div className="d-flex align-items-center gap-1">
                            <span className="rounded-pill" style={{ width: 12, height: 3, backgroundColor: "#f59e0b" }}></span>
                            <span className="text-muted fw-medium">LTV/CAC Ratio</span>
                        </div>
                    </div>

                    {/* COMBO CHART CONTAINER */}
                    <div className="flex-grow-1" style={{ minHeight: "220px", width: "100%" }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <ComposedChart
                                data={cacLtvData}
                                margin={{ top: 10, right: 0, left: -20, bottom: 0 }}
                                barGap={2}
                            >
                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />

                                {/* X Axis */}
                                <XAxis
                                    dataKey="year"
                                    tickLine={false}
                                    axisLine={{ stroke: '#e2e8f0' }}
                                    tick={{ fontSize: 10, fill: '#64748b' }}
                                />
                                {/* Left Y Axis - Dollar Amount */}
                                <YAxis
                                    yAxisId="left"
                                    tickLine={false}
                                    axisLine={false}
                                    tick={{ fontSize: 10, fill: '#64748b' }}
                                    tickFormatter={(val) => `$${val}`}
                                    domain={[0, 600]}
                                />

                                {/* Right Y Axis - LTV/CAC Ratio */}
                                <YAxis
                                    yAxisId="right"
                                    orientation="right"
                                    tickLine={false}
                                    axisLine={false}
                                    tick={{ fontSize: 10, fill: '#64748b' }}
                                    tickFormatter={(val) => `${val}x`}
                                    domain={[0, 5]}
                                />

                                <Tooltip
                                    contentStyle={{
                                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                        borderRadius: '8px',
                                        border: "1px solid #e3e3e3",
                                        fontSize: '11px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                                    }}
                                    formatter={(value, name) => [
                                        name === 'ratio' ? `${value}x` : `$${value}`,
                                        name === 'cac' ? 'CAC' : name === 'ltv' ? 'LTV' : 'LTV/CAC'
                                    ]}
                                />

                                {/* CAC Bar */}
                                <Bar yAxisId="left" dataKey="cac" fill="#849eff" radius={[2, 2, 0, 0]} maxBarSize={18} />

                                {/* LTV Bar */}
                                <Bar yAxisId="left" dataKey="ltv" fill="#c7d2fe" radius={[2, 2, 0, 0]} maxBarSize={18} />

                                {/* LTV/CAC Line */}
                                <Line
                                    yAxisId="right"
                                    type="monotone"
                                    dataKey="ratio"
                                    stroke="#f59e0b"
                                    strokeWidth={2.5}
                                    dot={false}
                                    activeDot={{ r: 4 }}
                                />
                            </ComposedChart>
                        </ResponsiveContainer>
                    </div>

                </Card.Body>
            </Card>
        </Col>

    )
}
